<template>
  <div>
    <div class="main-page">
      <div class="main-content">

        <div class="sub-title-box">
          <h3>邀请信息</h3>
          <div></div>
        </div>
        <el-form ref="mainForm" :model="formData" label-width="80px" class="main-form" size="small"
                 :rules="mainFormRules">


          <el-form-item v-for="item in forms" :prop="item.name" :label="item.title" :key="item.id">

            <el-cascader v-if="item.type === 'myAddress'" class="table-width-long" clearable
                         v-model="formData.myAddress" :options="areaData.areaLeave1">
            </el-cascader>

            <el-input
                v-else-if="item.type === 'input' || item.type === 'company' || item.type === 'comments'"
                class="table-width-long" v-model="formData[item.name]" :disabled="item.extIsReadyOnly">
            </el-input>

            <el-input
                v-else-if="item.type === 'car'  || item.type === 'car_num'"
                readonly @click.native="onCarClick"
                class="table-width-long" v-model="formData[item.name]" :disabled="item.extIsReadyOnly">
            </el-input>
            <el-date-picker
                v-else-if="item.type === 'timer'|| item.type === 'beginTime'|| item.type === 'endTime'" type="datetime"
                :editable="false" :picker-options="pickerOptions"
                class="table-width-long" v-model="formData[item.name]">
            </el-date-picker>

            <template v-else-if="item.type === 'file'">
              <el-input class="table-width-long" disabled v-model="formData[item.name]"
                        placeholder="暂不支持"></el-input>
            </template>

            <template v-else-if="item.type === 'number'">
              <el-input class="table-width-long" v-model="formData[item.name]"></el-input>
            </template>

            <template v-else-if="item.type === 'reason'">
              <el-select v-model="formData[item.name]" class="table-width-long"
                         @change="onSelectChange(item, item.valueListParse, formData[item.name])" clearable>
                <el-option v-for="child in item.valueListParse" :key="child.value" :label="child.value"
                           :value="child.value">
                </el-option>
              </el-select>
            </template>

            <template
                v-else-if="item.type === 'picker' || item.type === 'address' || item.type === 'list'  || item.type === 'reason' ">
              <el-select v-model="formData[item.name]" class="table-width-long"
                         @change="onSelectChange(item, item.valueListParse, formData[item.name])" clearable
                         :disabled="item.extIsReadyOnly">
                <el-option v-for="child in item.valueListParse" :key="child.value" :label="child.value"
                           :value="child.value">
                </el-option>
              </el-select>
            </template>
          </el-form-item>
        </el-form>

        <div class="sub-title-box">
          <h3>{{ editApplyId ? '修改邀约（仅时间与表单可改）' : '邀请访客' }}</h3>
          <el-button type="danger" size="mini" @click="addVisitor" plain v-if="!editApplyId">添加访客信息</el-button>
        </div>
        <el-table class="" :data="selectVisitor" border empty-text="请添加访客">
          <el-table-column prop="name" label="访客姓名" width="80"></el-table-column>
          <el-table-column prop="tel" label="访客手机" width="120"></el-table-column>
          <el-table-column prop="company" label="访客公司"></el-table-column>
          <el-table-column prop="ic" label="身份证号" v-if="visitorSetting.idCardNo !== 1">
            <template v-slot="scope">
              {{ scope.row.ic  | icNoFilter }}
            </template>
          </el-table-column>
          <el-table-column prop="nationality" label="访客国籍" v-if="visitorSetting.nationality !== 1 " width="80"></el-table-column>
          <el-table-column prop="mainVisitor" label="是否为主访人" width="110">
            <template v-slot="scope">
              <el-switch v-model="scope.row.mainVisitor" active-text="是" inactive-text="否" :active-value="true"
                         :inactive-value="false" @change="onMainVisitorChange(scope.row)"></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="分配卡号" width="140" v-if="!editApplyId">
            <template v-slot="scope">
              <el-input v-model="scope.row.extraCardNo" placeholder="请输入卡号" size="mini" clearable :disabled="scope.row.type === 'provider'"></el-input>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="80" v-if="!editApplyId">
            <template v-slot="scope">
              <el-button type="danger" size="mini" @click="onVisitorDel(scope.row)">移除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <div class="bottom-area">
          <div class="flex flex-col justify-center items-center">
            <el-button style="width: 300px" type="primary" @click="onApplyCommit" :disabled="agreement.show && !agreement.hasRead">提交</el-button>
            <el-checkbox v-model="agreement.hasRead" v-if="agreement.show" class="flex justify-start items-center mt-1.5">
              <div>
                <div><b>为了让您邀请的访客获得良好的访问体验，请阅读并同意如下访客须知。</b></div>
              </div>
            </el-checkbox>
          </div>

        </div>

        <div v-if="agreement.show" class="pb-10">
          <div class=" flex flex-col">
            <div class="flex justify-center text-xl font-bold"><span>访客须知</span></div>
            <div v-html="agreement.content"></div>
          </div>

        </div>
      </div>

    </div>

    <el-drawer :visible.sync="addDrawerShow" :with-header="false" :append-to-body="true"
               :close-on-click-modal="false" size="750px">
      <el-container>
        <el-tabs v-model="drawerActiveTab" :stretch="true" class="w-full">
          <el-tab-pane label="常邀访客" name="first">
            <div class="drawer-form-box">
              <div class=" center">
                <div class=" font-bold text-xl">添加访客</div>
              </div>

              <div class="flex flex-col  justify-start items-center overflow-y-auto w-full p-6">
                <el-form ref="drawerForm" :model="newVisitor" label-width="90px" class="flex flex-row flex-wrap" :rules="visitorRules" size="mini">
                  <el-form-item label="访客姓名" prop="name" class="w-1/2">
                    <el-input v-model="newVisitor.name" placeholder="请输入访客姓名" class="table-width-drawer"></el-input>
                  </el-form-item>
                  <el-form-item label=" 手机号码" prop="tel" class="w-1/2">
                    <el-input v-model="newVisitor.tel" placeholder="请输入手机号码" class="table-width-drawer"></el-input>
                  </el-form-item>
                  <el-form-item label=" 身份证号" prop="ic" v-if="visitorSetting.idCardNo !== 1" class="w-1/2">
                    <el-input v-model="newVisitor.ic" placeholder="请输入身份证号" class="table-width-drawer"></el-input>
                  </el-form-item>
                  <el-form-item label=" 访客国籍" prop="nationality" v-if="visitorSetting.nationality !== 1" class="w-1/2">
                    <el-input v-model="newVisitor.nationality" placeholder="请输入国籍" class="table-width-drawer"></el-input>
                  </el-form-item>
                  <el-form-item label=" 公司名称" prop="company" class="w-1/2">
                    <el-input v-model="newVisitor.company" placeholder="请输入公司名称" class="table-width-drawer"></el-input>
                  </el-form-item>
                  <el-form-item class="w-full">
                    <el-button style="margin-left: 210px" type="primary" @click="onDrawerAddUsual">创建常邀访客</el-button>
                  </el-form-item>
                </el-form>
                <div style="height: 1px; width: 100%; background-color: #efefef; margin-top: 10px; margin-bottom: 10px"></div>
                <h3>从常邀访客中选择</h3>
                <el-form :model="visitorSearch" size="mini">
                  <el-form-item label="搜索访客" prop="company" label-width="90px" class="drawer-form">
                    <el-input v-model="visitorSearch.searchInput" placeholder="请输入访客姓名或手机号" class="table-width-drawer">
                      <el-button slot="append" icon="el-icon-search" @click="onSearchVisitor"></el-button>
                    </el-input>
                  </el-form-item>
                </el-form>
                <el-table class="drawer-table" :data="searchVisitorResult" ref="multipleTable" border stripe size="mini">
                  <el-table-column prop="name" label="访客姓名"></el-table-column>
                  <el-table-column prop="tel" label="手机号码"></el-table-column>
                  <el-table-column prop="company" label="公司名称"></el-table-column>
                  <el-table-column prop="ic" label="身份证号" v-if="visitorSetting.idCardNo !== 1">
                    <template v-slot="scope">
                      {{ scope.row.ic  | icNoFilter }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="nationality" label="访客国籍" v-if="visitorSetting.nationality !== 1" width="100"></el-table-column>
                  <el-table-column label="操作" width="150">
                    <template v-slot="scope">
                      <el-button type="success" size="mini" @click="onDrawerSelectVisitor(scope.row)">选择</el-button>
                      <el-button type="danger" size="mini" @click="onDrawerRemoveVisitor(scope.row)">移除</el-button>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="供应商访客" name="second">
            <div class="drawer-form-box">
              <div class=" center pb-4">
                <div class=" font-bold text-xl">添加访客</div>
              </div>
              <el-form :inline="true" :model="provideSearch" :rules="providerRules" size="mini" @submit.native.prevent>
                <el-form-item label="搜索方式" prop="searchType">
                  <el-select v-model="provideSearch.searchType" placeholder="请选择搜索方式">
                    <el-option label="企业名称" value="company"></el-option>
                    <el-option label="人员姓名" value="name"></el-option>
                    <el-option label="访客卡号" value="cardNo"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="搜索内容" prop="searchInput">
                  <el-input v-model="provideSearch.searchInput" placeholder="请输入搜索内容">
                    <el-button slot="append" icon="el-icon-search" @click="onSearchProvideVisitor"></el-button>
                  </el-input>
                </el-form-item>
              </el-form>
              <el-table class="drawer-table" :data="provideSearchResult" ref="multipleTable" border size="mini">
                <el-table-column prop="name" label="访客姓名"></el-table-column>
                <el-table-column prop="cardNo" label="访客卡号"></el-table-column>
                <el-table-column prop="company" label="访客公司"></el-table-column>
                <el-table-column prop="ic" label="身份证号" v-if="visitorSetting.idCardNo !== 1">
                  <template v-slot="scope">
                    {{ scope.row.ic  | icNoFilter }}
                  </template>
                </el-table-column>
                <el-table-column prop="nationality" label="访客国籍" v-if="visitorSetting.nationality !== 1"></el-table-column>
                <el-table-column label="操作" width="150">
                  <template v-slot="scope">
                    <el-button type="success" size="mini" @click="onDrawerSelectVisitor(scope.row)">选择</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-tab-pane>
        </el-tabs>


        <el-footer class="center">
          <el-button @click="addDrawerShow = false">返 回</el-button>
        </el-footer>
      </el-container>
    </el-drawer>

    <my-notify-dialog :show="notify.show" :success="notify.success" :msg="notify.msg" :title="notify.title"
                      @dialogClose="onDialogClose"></my-notify-dialog>

    <el-dialog title="车牌号录入" :visible.sync="carVisible" width="80%" center>
      <car-keyboard ref="carKeyboard" :onConfirm="onCarConfirm" :onCancel="onCarCancel" :onClear="onCarClear"></car-keyboard>
    </el-dialog>
  </div>
</template>

<script>

import {getAreaList} from "@/api/mobile/mobile-area-api";
import {addApply, getInviteForm, updateApplyByEmployee} from "@/api/mobile/mobile-apply-api";
import {addUsualVisitor, deleteUsualVisitor, getUsualVisitor} from "@/api/mobile/mobile-usual-api";
import {searchVisitor, visitorAdd, getVisitorByBatch} from "@/api/mobile/mobile-visitor-api";
import MyNotifyDialog from "@/components/MyNotifyDialog.vue";
import {getInviteVisitorFormSettingWithMobile, getVisitorAgreementFromSetting} from "@/api/mobile/mobile-setting-api";
import CarKeyboard from '@/components/carkeyboard/CarKeyboard.vue'


export default {
  components: {MyNotifyDialog, CarKeyboard},
  data() {
    return {
      selectVisitor: [],

      // 修改模式：由申请记录页跳入，仅可修改时间与表单内容
      editApplyId: null,
      editApply: null,

      newVisitor: {
        name: '',
        tel: '',
        ic: '',
        company: '',
        nationality: '',
      },
      visitorRules: {
        name: [
          {required: true, message: '请输入姓名', trigger: 'blur'}
        ],
        tel: [
          {required: true, message: '请输入手机号', trigger: 'blur'},
          {type: 'string', pattern: /^[1][0-9]{10}$/, message: '请输入正确的手机号', trigger: 'blur'}
        ],
        company: [
          {required: true, message: '请输入公司名称', trigger: 'blur'}
        ],
      },

      historyVisitor: [],
      searchVisitorResult: [],
      addDrawerShow: false,

      hasPeer: false,
      visitorSearch: {
        searchInput: ""
      },

      formData: {},
      forms: [],
      mainFormRules: {},

      areaData: {
        areaLeave1: [],
        areaVerifySwitch: false,
      },

      signOutTime: "",

      notify: {
        title: "",
        show: false,
        success: false,
        msg: ""
      },
      visitorSetting: {
        idCardNo: 2, // 身份证号设置  1不展示， 2选填， 3必填; 默认选填
        nationality: 1, // 国籍设置  1不展示， 2选填， 3必填； 默认不展示
      },
      pickerOptions: {
        disabledDate(time) {
          let now = new Date()
          let today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
          return time.getTime() < today.getTime();
        }
      },

      drawerActiveTab: "first",
      provideSearch: {
        searchType: "company",
        searchInput: ""
      },
      providerRules: {
        searchType: [
          {required: true, message: '请选择搜索方式', trigger: 'blur'}
        ],
        searchInput: [
          {required: true, message: '请输入搜索内容', trigger: 'blur'}
        ]
      },
      provideSearchResult: [],
      fullscreenLoading: false,

      agreement: {
        show: false,
        hasRead: false,
        content: "",
      },
      carVisible: false,
    };


  },
  mounted() {

    // 修改模式：读取记录页带来的原申请
    let editRaw = sessionStorage.getItem('inviteEditApply')
    if (editRaw) {
      sessionStorage.removeItem('inviteEditApply')
      try {
        this.editApply = JSON.parse(editRaw)
        this.editApplyId = this.editApply ? this.editApply.id : null
      } catch (e) {
        this.editApply = null
        this.editApplyId = null
      }
    }

    getVisitorAgreementFromSetting().then(({data}) => {
      // state: isOpen === 1 ? "VALID" : "INVALID",
      if (data.code === 200 && data.data.length > 0) {
        let item = data.data[0]
        this.agreement.show = item.state === "VALID"
        this.agreement.content = item.content
      }
    }).catch((err) => {
      console.log("getVisitorAgreementFromSetting", err)
    })

    getAreaList().then(({data}) => {
      if (data.code === 200) {
        this.areaData.areaLeave1 = data.data
        data.data.forEach((item) => {
          item.value = item.id
          item.label = item.name
          item.children = item.areas
          item.children.forEach((item2) => {
            item2.value = item2.id
            item2.label = item2.name
            if (item2.verify === 1) {
              this.areaData.areaVerifySwitch = true
              this.mainFormRules.myAddress = [{required: true, message: '到访地址必填项', trigger: 'blur'}]
            }
          })
        })
        this.fixForms()
      }
    })
    getInviteForm().then(({data}) => {
      console.log("getInviteForm 111", data)
      if (data.code === 200) {
        data.data.formItems.forEach((item) => {
          console.log("item", item)
          if (item.valueList) {
            item.valueListParse = JSON.parse(item.valueList)
          }
          if (item.required) {
            this.mainFormRules[item.name] = [{required: true, message: `${item.title}必填`, trigger: 'blur'}]
          } else {
            this.mainFormRules[item.name] = [{required: false}]
          }
          if (item.type !== "accompany") {
            this.forms.push(item)
          } else {
            this.hasPeer = true
          }
        })
        this.fixForms()
        console.log("mainFormRules", this.mainFormRules)
        if (this.editApplyId) {
          this.prefillEditApply()
        }
      }
    })
    getUsualVisitor().then(({data}) => {
      console.log("getUsualVisitor", data)
      if (data.code === 200) {
        this.historyVisitor = data.data.filter(item => item.type !== "black")
        this.searchVisitorResult = this.historyVisitor
      } else {
        console.log()
      }
    })
    getInviteVisitorFormSettingWithMobile().then(({data}) => {
      console.log("getInviteVisitorFormSettingWithMobile", data)
      if (data.code === 200) {
        data.data.forEach(item => {
          if (item.type === "VISITOR_INVITE") {
            let content = JSON.parse(item.content)
            if (content) {
              this.visitorSetting.idCardNo = content.idCardNo
              this.visitorSetting.nationality = content.nationality
            }
          }
        })
      }
      if (this.visitorSetting.idCardNo === 3) {
        this.visitorRules.ic = [{required: true, message: '请输入身份证号', trigger: 'blur'}]
      }
      if (this.visitorSetting.nationality === 3) {
        this.visitorRules.nationality = [{required: true, message: '请输入国籍', trigger: 'blur'}]
      }
    }).catch((err) => {
      this.showNetErrMsg(err)
    })

  },

  methods: {

    onCarClick() {
      document.activeElement.blur()
      this.carVisible = true
    },

    startAutoCloseTimer() {
      if (this.autoCloseTimer) {
        clearTimeout(this.autoCloseTimer)
      }
      this.autoCloseTimer = setTimeout(() => {
        this.autoCloseTimer = null
        this.onDialogClose()
      }, 2000)
    },

    //表单中 选择框改变监听
    onSelectChange(item, valueList, selectValue) {
      console.log("onSelectChange1", item)
      console.log("onSelectChange2", valueList)
      console.log("onSelectChange3", selectValue)
      if (item.valueSelect && item.valueSelect.dependField) {
        this.dealDependFieldRemove(item.valueSelect)
      }
      item.valueSelect = null

      let i
      for (i = 0; i < valueList.length; i++) {
        if (valueList[i].value === selectValue && valueList[i].dependField || valueList[i].signOutTime) {
          this.dealDependFieldAdd(valueList[i])

          item.valueSelect = valueList[i]
          break;
        }
      }
    },

    // 处理依赖字段移除
    dealDependFieldRemove(selectValue) {
      if (selectValue.signOutTime) {
        this.signOutTime = ""
      }
      let formItemTarget = this.forms.find(formItem => {
        return formItem.id === selectValue.dependField
      });

      if (formItemTarget) {
        formItemTarget.extRequired = 0

        if (formItemTarget.required) {
          this.mainFormRules[formItemTarget.name] = [{required: true, message: '必填项', trigger: 'blur'}]
        } else {
          this.mainFormRules[formItemTarget.name] = [{required: false}]
        }

        if (selectValue.isReadyOnly) {
          formItemTarget.extIsReadyOnly = false
          this.formData[formItemTarget.name] = ""
        }
      }
    },

    // 处理依赖字段添加
    dealDependFieldAdd(selectValue) {
      if (selectValue.signOutTime) {
        this.signOutTime = selectValue.signOutTime
      }
      let filter = this.forms.filter(formItem => {
        return formItem.id === selectValue.dependField
      });
      if (filter.length > 0) {
        filter[0].extRequired = 1
        this.mainFormRules[filter[0].name] = [{required: true, message: '必填项', trigger: 'blur'}]

        let oneFormItem = this.forms.find(formItem => {
          return formItem.id === selectValue.dependField
        })
        oneFormItem.extRequired = true

        if (selectValue.isReadyOnly) {
          filter[0].extIsReadyOnly = true
          this.formData[filter[0].name] = selectValue.readyValue
        }
      }
    },

    addVisitor() {
      this.newVisitor = {name: '', tel: '', company: '', ic: ''}
      this.provideSearchResult = []
      this.provideSearch = {searchInput: "", searchType: "company"}
      this.visitorSearch.searchInput = ""
      this.searchVisitorResult = this.historyVisitor
      this.addDrawerShow = true
    },

    onDrawerAddUsual() {
      if (this.$refs.drawerForm.validate()) {
        let {name, tel, company, ic, nationality} = this.newVisitor
        visitorAdd(name, tel, company, ic, nationality).then(({data}) => {
          if (data.code === 200) {
            if (data.data.type === 'black') {
              this.$message.error("添加失败，该访客已被列入黑名单")
              return
            }
            this.historyVisitor.unshift(data.data)
            this.searchVisitorResult = this.historyVisitor
            addUsualVisitor(data.data.code).then(({data}) => {
              console.log("addUsualVisitor", data.code)
            }).catch(err => {
              console.error("addUsualVisitor", err)
            })
            this.newVisitor = {name: '', tel: '', company: '', ic: ''}
            this.$message.success("添加成功")
          } else {
            console.warn("visitorLogin false", data.code, data.msg)
            this.showServerErrMsg(data.code)
          }
        }).catch(err => {
          console.error("visitorLogin err", err)
          this.showNetErrMsg()
        })
      }
    },

    onSearchVisitor() {
      if (!this.visitorSearch.searchInput) {
        this.searchVisitorResult = this.historyVisitor
      } else {
        this.searchVisitorResult = this.historyVisitor.filter(item => {
          return (item.name ?? "").includes(this.visitorSearch.searchInput) || item.tel.includes(this.visitorSearch.searchInput)
        })
      }
    },

    onSearchProvideVisitor() {
      console.log("onSearchProvideVisitor")
      let searchInput = this.provideSearch.searchInput
      if (!searchInput) {
        this.$message.error("请输入搜索内容")
        return
      }
      this.searchVisitorResult = []

      let postData = {type: "provider",}
      if (this.provideSearch.searchType === "company") {
        postData.company = searchInput
      } else if (this.provideSearch.searchType === "name") {
        postData.name = this.provideSearch.searchInput
      } else if (this.provideSearch.searchType === "cardNo") {
        postData.cardNo = this.provideSearch.searchInput
      }
      searchVisitor(postData).then(({data}) => {
        console.log("onSearchProvideVisitor", data)
        if (data.code === 200) {
          this.provideSearchResult = data.data
        }
      }).catch(err => {
        console.error("searchVisitor err", err)
      })
    },

    onDrawerSelectVisitor(row) {
      this.onAddOneVisitor(row)
    },

    onDrawerRemoveVisitor(row) {
      this.$confirm('是否从常访中移除该访客?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.onDrawTableDel(row)
      }).catch(() => {
        console.log("cancel")
      });
    },

    onAddOneVisitor(visitor) {
      if (this.visitorSetting.idCardNo === 3 && !visitor.ic) {
        this.$message.error("添加失败，请到常邀访客中为该访客添加身份证号")
        return
      }
      if (this.visitorSetting.nationality === 3 && !visitor.nationality) {
        this.$message.error("添加失败，请到常邀访客中为该访客添加国籍")
        return
      }
      if (visitor.type === "black") {
        this.$alert(`访客：${visitor.name}，手机号：${visitor.tel}，为黑名单访客`, "提示", {confirmButtonText: "确定"})
        return
      }
      if (this.selectVisitor.length === 0) {
        if (visitor.type === "provider") {
          this.$set(visitor, "extraCardNo", visitor.cardNo)
        }
        const newVisitor = Object.assign({}, visitor, {mainVisitor: true})
        this.selectVisitor.push(newVisitor)
        return
      }
      if (!this.hasPeer) {
        if (visitor.type === "provider") {
          this.$set(visitor, "extraCardNo", visitor.cardNo)
        }
        const newVisitor = Object.assign({}, visitor, {mainVisitor: true})
        this.selectVisitor = []
        this.selectVisitor.push(newVisitor)
        return
      }

      let findIndex = this.selectVisitor.findIndex(item => item.id === visitor.id)
      if (findIndex === -1) {
        visitor.mainVisitor = false
        if (visitor.type === "provider") {
          this.$set(visitor, "extraCardNo", visitor.cardNo)
        }
        const newVisitor = Object.assign({}, visitor, {mainVisitor: false})

        this.selectVisitor.push(newVisitor)
      } else {
        this.$message.warning("该访客已存在")
      }
    },


    onDialogClose() {
      if (this.autoCloseTimer) {
        clearTimeout(this.autoCloseTimer)
      }
      const wasEdit = !!this.editApplyId
      this.autoCloseTimer = null
      this.notify.show = false
      this.selectVisitor = []
      this.formData = {}
      this.$refs.mainForm.clearValidate()
      this.$refs.carKeyboard.clear()
      if (wasEdit) {
        this.editApplyId = null
        this.editApply = null
        this.$router.back()
      }
    },

    // 修改模式：按原申请回填时间/表单/访客（访客只读展示）
    prefillEditApply() {
      const apply = this.editApply
      if (!apply) {
        return
      }
      const todate = (d, t) => new Date(`${d.substring(0, 10)}T${t.substring(0, 8)}`)
      this.$set(this.formData, 'startTime', todate(apply.beginDate, apply.beginTime))
      this.$set(this.formData, 'endTime', todate(apply.endDate, apply.endTime))
      ;(apply.forms || []).forEach((f) => {
        const item = this.forms.find((i) => i.id === f.id)
        if (item && item.type !== 'beginTime' && item.type !== 'endTime') {
          this.$set(this.formData, item.name, f.value)
        }
      })
      const main = Object.assign({}, apply.visitor, {mainVisitor: true})
      this.selectVisitor = [main]
      if (apply.accompanies) {
        getVisitorByBatch(apply.accompanies.split('|')).then(({data}) => {
          if (data.code === 200 && data.data) {
            data.data.forEach((v) => {
              this.selectVisitor.push(Object.assign({}, v, {mainVisitor: false}))
            })
          }
        }).catch((err) => {
          console.error("prefillEditApply getVisitorByBatch err", err)
        })
      }
    },

    onDrawTableDel(row) {
      // this.selectVisitor 中 删除 item
      let find = this.selectVisitor.findIndex((item, index) => item.id === row.id)
      if (find !== -1) {
        this.selectVisitor.splice(find, 1)
      }

      find = this.historyVisitor.findIndex((item, index) => item.id === row.id)
      if (find !== -1) {
        this.historyVisitor.splice(find, 1)
      }
      find = this.searchVisitorResult.findIndex((item, index) => item.id === row.id)
      if (find !== -1) {
        this.searchVisitorResult.splice(find, 1)
      }

      deleteUsualVisitor(row.code).then(({data}) => {
        if (data.code === 200) {
          console.log("deleteUsualVisitor success")
        } else {
          console.warn("deleteUsualVisitor false", data.code, data.msg)
        }
      }).catch(err => {
        console.error("deleteUsualVisitor err", err)
      })
    },

    onApplyCommit() {
      if (this.fullscreenLoading) {
        return
      }
      this.fullscreenLoading = true
      if (this.selectVisitor.length === 0) {
        this.$message.error("请添加访客")
        this.fullscreenLoading = false

        return
      }
      let visitor = this.selectVisitor.find(item => item.mainVisitor)
      if (!visitor) {
        this.$message.error("请选择主访客")
        this.fullscreenLoading = false

        return
      }

      this.$refs.mainForm.validate().then((mainFormValid) => {
        if (!mainFormValid) {
          this.$message.error("请先完善表单信息");
          this.fullscreenLoading = false
          return;
        }
        console.log("onApplyCommit form check pass");
        this.doApplyCommit()
      }).catch(err => {
        console.error("onApplyCommit form check err", err)
        this.fullscreenLoading = false
      });
    },

    getFormItems() {
      let res = []
      this.forms.forEach(item => {
        if (item.type === "myAddress") {
          return
        }
        if (item.type !== 'beginTime' && item.type !== 'endTime') {
          item.value = this.formData[item.name]
        }

        res.push(item)
      })
      return res
    },

    doApplyCommit() {
      if (this.editApplyId) {
        this.doApplyUpdate()
        return
      }
      let visitor = this.selectVisitor.find(item => item.mainVisitor)
      let peerList = this.selectVisitor.filter(item => !item.mainVisitor)
      let accompanyCards = {}
      peerList.forEach((item, index) => {
        if (item.extraCardNo) {
          accompanyCards[item.code] = item.extraCardNo
        }
      })

      console.log("doApplyCommit", this.formData)

      let apply = {}
      apply.employeeId = this.$store.state.employeeLoginInfo.id
      apply.employeeCode = this.$store.state.employeeLoginInfo.code
      apply.visitorCode = visitor.code
      apply.visitorId = visitor.id
      apply.type = "INVITE_APPLY"
      apply.accompanies = peerList.map(item => item.code).join('|')
      apply.device = "web"
      apply.checkoutTime = this.signOutTime
      apply.visitorCardNo = visitor.extraCardNo
      apply.accompanyCards = accompanyCards
      apply.entryArea = null
      if (this.areaData.areaVerifySwitch && this.formData.myAddress.length === 2) {
        let superArea = this.areaData.areaLeave1.find(item => item.id === this.formData.myAddress[0])
        let subArea = (superArea.areas || []).find(item => item.id === this.formData.myAddress[1])
        console.log("subArea", subArea)
        apply.entryArea = subArea.id
      }
      let startTime = new Date(this.formData.startTime)
      let endTime = new Date(this.formData.endTime)
      if (startTime.getTime() >= endTime.getTime()) {
        this.$message.error("结束时间必须大于开始时间")
        this.fullscreenLoading = false
        return
      }

      apply.beginDate = startTime.getFullYear() + "-" + ('0' + (startTime.getMonth() + 1)).slice(-2) + "-" + ('0' + startTime.getDate()).slice(-2)
      apply.endDate = endTime.getFullYear() + "-" + ('0' + (endTime.getMonth() + 1)).slice(-2) + "-" + ('0' + endTime.getDate()).slice(-2)
      apply.beginTime = ('0' + startTime.getHours()).slice(-2) + ":" + ('0' + startTime.getMinutes()).slice(-2) + ":" + ('0' + startTime.getSeconds()).slice(-2)
      apply.endTime = ('0' + endTime.getHours()).slice(-2) + ":" + ('0' + endTime.getMinutes()).slice(-2) + ":" + ('0' + endTime.getSeconds()).slice(-2)
      apply.forms = this.getFormItems()

      console.log("todo doApplyCommit params ", apply)


      addApply(apply).then(({data}) => {
        if (data.code === 200) {
          this.notify = {title: "邀请结果", show: true, success: true, msg: "邀请成功"}
          this.startAutoCloseTimer()
        } else {
          console.warn("addApply false", data.code, data.msg)
          this.showServerErrMsg(data.code)
        }
        this.fullscreenLoading = false

      }).catch(err => {
        console.error("addApply err", err)
        this.fullscreenLoading = false

        this.showNetErrMsg()
      })
    },

    // 修改模式提交：仅更新时间与表单，访客名单保持不变
    doApplyUpdate() {
      let startTime = new Date(this.formData.startTime)
      let endTime = new Date(this.formData.endTime)
      if (startTime.getTime() >= endTime.getTime()) {
        this.$message.error("结束时间必须大于开始时间")
        this.fullscreenLoading = false
        return
      }
      let apply = {
        id: this.editApplyId,
        employeeId: this.$store.state.employeeLoginInfo.id,
        beginDate: startTime.getFullYear() + "-" + ('0' + (startTime.getMonth() + 1)).slice(-2) + "-" + ('0' + startTime.getDate()).slice(-2),
        endDate: endTime.getFullYear() + "-" + ('0' + (endTime.getMonth() + 1)).slice(-2) + "-" + ('0' + endTime.getDate()).slice(-2),
        beginTime: ('0' + startTime.getHours()).slice(-2) + ":" + ('0' + startTime.getMinutes()).slice(-2) + ":" + ('0' + startTime.getSeconds()).slice(-2),
        endTime: ('0' + endTime.getHours()).slice(-2) + ":" + ('0' + endTime.getMinutes()).slice(-2) + ":" + ('0' + endTime.getSeconds()).slice(-2),
        forms: this.getFormItems(),
      }
      updateApplyByEmployee(apply).then(({data}) => {
        if (data.code === 200) {
          this.notify = {title: "修改结果", show: true, success: true, msg: "修改成功"}
          this.startAutoCloseTimer()
        } else {
          console.warn("updateApplyByEmployee false", data.code, data.msg)
          this.$message.error(data.msg || "修改失败")
        }
        this.fullscreenLoading = false
      }).catch(err => {
        console.error("updateApplyByEmployee err", err)
        this.fullscreenLoading = false
        this.showNetErrMsg()
      })
    },

    onMainVisitorChange(row) {
      console.log("onMainVisitorChange", row.name, row.mainVisitor)
      if (row.mainVisitor) {
        this.selectVisitor.forEach(item => {
          if (item.id !== row.id) {
            item.mainVisitor = false
          }
        })
      }
    },

    onVisitorDel(row) {
      let findIndex = this.selectVisitor.findIndex(item => item.id === row.id)
      if (findIndex !== -1) {
        this.selectVisitor.splice(findIndex, 1)
      }
    },
    fixForms() {
      if (this.areaData.areaVerifySwitch && this.forms.length > 2) {
        // 在 第三个位置插入到访地址
        this.forms.splice(2, 0, {
          id: 123456789,
          name: "myAddress",
          title: "到访地址",
          type: "myAddress",
          required: 1,
          extRequired: 0,
          extIsReadyOnly: false,
          valueListParse: [],
        })
      }
    },

    onCarConfirm(carNo) {
      console.log("onCarConfirm", carNo)
      this.formData.carNumber = carNo
      this.carVisible = false
    },

    onCarCancel() {
      console.log("onCarCancel")
      this.carVisible = false
    },

    onCarClear() {
      console.log("onCarClear")
      this.formData.carNumber = ""
    },

  }, // methods
  computed: {
    hasCommitPermission() {
      switch (this.$store.state.roleType) {
        case "STAFF":
          return true
        default:
          return false
      }
    }
  },

}
</script>

<style scoped lang="less">


.main-form {
  width: 800px;

  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;


  .table-width-long {
    width: 300px;
  }
}

.center {
  text-align: center;
}

.peerTable {
  margin-top: 10px;
}

.el-container {
  height: 100%;
  width: 100%;

  .el-header, .el-footer {
    height: 60px;
    line-height: 60px;
  }

}

.drawer-form-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow-y: auto;
  height: calc(100vh - 120px);

}

.drawer-form {
  width: 380px;
  //margin-left: 100px;
  .table-width-drawer {
    width: 300px;
  }
}

.drawer-table {
  overflow-y: auto;
}

.el-table /deep/ .disabledCheck .cell .el-checkbox__inner {
  display: none !important;
}

.el-table /deep/ .disabledCheck .cell:before {
  content: "选择";
  position: absolute;
  right: 11px;
}

.bottom-area {
  padding: 20px;
  line-height: 80px;
  text-align: center;
}

.main-page {
  height: calc(100vh - 120px);
  background-color: white;

  display: flex;
  flex-direction: column;
  align-items: center;


  .main-content {
    width: 800px;
  }

  .sub-title-box {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    //margin-bottom: 20px;
    //margin-top: 30px;
  }

  .subTitle {
    font-size: 20px;
    font-weight: bold;
  }

}

.el-table::before {
  height: 0;
}

///deep/ .el-checkbox__input {
//  margin-bottom: 20px;
//}
</style>
